import React from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AnimationOnScroll } from 'react-animation-on-scroll';


const Discover = () => {
    const navigate = useNavigate();
    const handleContactClick = () => {
        navigate('/contact-us'); // Ganti dengan path sesuai routing kamu
    };

    return (
        <Container className="py-5 discover" style={{ backgroundColor: '#348CFF', color: '#fff' }}>
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
            <div className="row justify-content-center text-center">
                <div className="col-lg-8">
                    <h1 className="fw-bold mb-2">Discover Tailored Digital Solutions</h1>
                    <h2 className="mb-4">That Drive Results</h2>
                    <p className="mb-5 fs-5 content text-center">
                        Tell us what you need&nbsp;&nbsp;we’re ready to help.
                    </p>
                    <button
                        className="btn btn-lg"
                        onClick={handleContactClick}
                        style={{
                            backgroundColor: '#fff',
                            color: '#348CFF',
                            fontWeight: 'bold',
                            borderRadius: '2rem',
                            padding: '0.75rem 2.5rem',
                            border: 'none'
                        }}
                    >
                        Contact Us
                    </button>
                </div>
            </div>
            </AnimationOnScroll>
        </Container>
    );
};

export default Discover;